import { fields } from '@apparel/core/api/utils';
import { SeoPage } from '@apparel/core/models/SeoPage';
import { PlatformService, SupportedCompanies } from '@apparel/core/platform';
import { WEBSITE_TITLE_TEMPLATE } from '@constants/Defaults';
import { fontUrl } from '@lib/style/fontUrl';
import { ApplicationContext } from '@packages/layout';
import { createMemo } from '@packages/react';
import { FONTS } from '@packages/style/themes/default/fonts';
import React, { useContext, useEffect, useMemo, useState } from 'react';
import { Helmet } from 'react-helmet';

export const PageHead = createMemo(
    () => {
        const [state] = useContext(ApplicationContext);
        const fonts$ = useMemo(() => Object.values(FONTS), [FONTS]);
        const [seo, setSeo] = useState<SeoPage | null>(null);

        const siteName = useMemo(() => {
            if (seo?.title) {
                return seo.title;
            }

            if (PlatformService.match(SupportedCompanies.GAMEBREAKER)) {
                return 'GameBreaker';
            }

            return 'Wooter Apparel';
        }, [seo]);

        const titleTemplate = useMemo(() => WEBSITE_TITLE_TEMPLATE(siteName), [siteName]);

        useEffect(() => {
            SeoPage.getSeoOfPage('@', fields(['title', ['favicon', ['file_path']]])).then((seo) => {
                setSeo(seo);
            });
        }, []);

        return (
            <Helmet titleTemplate={titleTemplate} defaultTitle={siteName}>
                <title>{state.getIn(['page', 'title']) || siteName}</title>
                <meta name={'version'} content={process.env.VERSION} />
                <meta
                    name="viewport"
                    content="minimum-scale=1, initial-scale=1, width=device-width, shrink-to-fit=no"
                />
                <link rel={'stylesheet'} href={fontUrl(fonts$)} />
                {seo?.favicon?.file_path ? (
                    <link href={seo.favicon.file_path} rel="shortcut icon" type="x-icon" />
                ) : null}
            </Helmet>
        );
    },
    {
        displayName: 'PageHead',
    },
);
